import { Dispatch, SetStateAction, useContext, useEffect, useRef, useState } from 'react'
import { AiOutlineClose } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../AuthProvider';
import moment from 'moment';
import { activeMembership, checkPaymentChargeWithCondition, getAllCards, getClubMemberships, handleRemoveCard, ICard, IPaymentIntent } from '../../Api/api';
import { BsCheckCircle, BsCheckCircleFill } from 'react-icons/bs';
import Popup from '../booking/Popup';
import { Store } from 'react-notifications-component';
import PopupInfo from '../booking/PopupInfo';
import { CardElement, useStripe } from '@stripe/react-stripe-js';
import { checkNullAndUndefined, correctAmountWithDecimal } from '../../Utilities/utils';
import Axios from '../../Api/Axios';
import { ConfirmCardPaymentData } from '@stripe/stripe-js';
import MembershipSuccessModal from './MembershipSuccessModal';
import { MemberShipDetails } from './ClubProfileMembership';

export interface IMembershipRequest {
    player_id: string;
    birth_date?: any;
    phone_number: string;
    address: string;
    postal_no: string;
    county: string;
    country: string;
    club_id: string;
    membership_id: string;
    following: boolean;
    payment_status: string;
    next_payment: number;
    subscription_id: string;
    Date_of_birth?:any;
    personalNumber?: string;
  }

export const MembershipPaymentDetailsModal = ({
    membership,
    clubData,
    formData,
    setOpenMembershipPaymentDetails,
    setClubMemberships,
    isLoading,
    setLoading,
    setOpenMembershipModal
}: {
    membership: any;
    clubData: any;
    formData: MemberShipDetails;
    setOpenMembershipPaymentDetails: Dispatch<SetStateAction<boolean>>;
    setClubMemberships: Dispatch<SetStateAction<any>>;
    isLoading: boolean;
    setLoading: Dispatch<SetStateAction<boolean>>;
    setOpenMembershipModal: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation();
  const currentUser: any = useContext(AuthContext);
  const stripe = useStripe();
  const [showCardPayment, setShowCardPayment] = useState(false);
  const [isLoadingCards, setIsLoadingCards] = useState(true);
  const [savedCards, setSavedCards] = useState([]);
  const [showSavedCards, setShowSavedCards] = useState(false);
  const [cardsFetching, setCardsFetching] = useState(true);
  const [selectedCard, setSelectedCard] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [infoPopupTitle, setInfoPopupTitle] = useState("");
  const [infoPopupSubtitle, setInfoPopupSubtitle] = useState("");
  const [cardElement, setCardElement] = useState<any>(null);
  const [cardDetails, setCardDetails] = useState<any>();
  const [saveCardForFutureUse, setSaveCardForFutureUse] = useState(false);
  const cardElementRef = useRef<any>(null);
  const [isModalVisible, setModalVisible] = useState(false);
  const [disablePayClick, setDisablePayClick] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  useEffect(() => {
          if (
              (cardsFetching && !savedCards.length) ||
              (cardsFetching && deleted)
          ) {
              const delay = 3000; // Delay in milliseconds (3 seconds)
              const timeoutId = setTimeout(() => {
                  getAllCards(setCardsFetching)
                      .then((resp) => {
                          setCardsFetching(false);
                          const _activeCard = resp?.paymentMethods?.find(
                              (card: any) => card.defaultPaymentMethod
                          );
                          if (_activeCard) {
                              setSelectedCard(_activeCard.stripePaymentMethodId);
                              localStorage.setItem(
                                "activeCard",
                                JSON.stringify(_activeCard)
                            );
                          }
  
                          if (resp?.paymentMethods.length) {
                              setSavedCards(resp?.paymentMethods);
                              localStorage.setItem(
                                  "savedCards",
                                  JSON.stringify(resp?.paymentMethods)
                              );
                          } else {
                              setSavedCards([]);
                              localStorage.removeItem("savedCards");
                          }
                          setShowSavedCards(true);
                          setIsLoadingCards(false);
                          setDeleted(false);
                      })
                      .catch(() => setIsLoadingCards(false));
              }, delay);
  
              return () => clearTimeout(timeoutId);
          } else {
              setIsLoadingCards(false);
              setShowSavedCards(true);
          }
      }, [cardsFetching, savedCards, deleted]);

      useEffect(() => {
        if (showCardPayment && stripe) {
          setSelectedCard("");
            // const cardElement = elements.getElement(CardElement);
            // cardElementRef.current = cardElement;
        } else {
            cardElementRef.current = null;
            setCardDetails(null);
            setSaveCardForFutureUse(false);
        }
        handleCardElementSelect(cardElementRef.current);
        return () => {
            handleCardElementSelect(null);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showCardPayment]);

    const handleCardElementSelect = (element: any) => {
      setCardElement(element);
    };

    const handleCardElementChange = (e: any) => {
      setCardDetails(e);
    };

    function calculatePercentage(amount: any, percentage: any) {
        if (checkNullAndUndefined(percentage) || checkNullAndUndefined(amount)) {
          return 0 ;
        }
        return (amount * percentage) / 100;
      }

    const fareAmountMembership = () => {
    
        let shareValue = membership?.price;
        let salesValue = 0;
        if (!checkNullAndUndefined(clubData?.salestax) && clubData?.salestax?.salestax_on_top) {
          salesValue = calculatePercentage(membership?.price, clubData?.salestax?.salestax_percentage)
          if (salesValue < 0) {
            salesValue = 0;
          }
        }
        shareValue = shareValue + salesValue
        return shareValue;
      }

    const salesTaxAmount = () => {
        const value = Number(correctAmountWithDecimal(fareAmountMembership())) - Number(correctAmountWithDecimal(membership?.price))
        if (value < 0) {
          return 0
        }
        return value
      }

    const showPopupInfoBox = (title: string, subTitle: string) => {
    setInfoPopupTitle(title);
    setInfoPopupSubtitle(subTitle);
    setIsLoadingCards(true);
    };

    const handleDeleteCard = () => {
        const selectedPaymentCard: any = savedCards.find(
            (c: any) => c.stripePaymentMethodId === selectedCard
        );
        showPopupInfoBox(
            "Card removal",
            "Please wait while we remove your card..."
        );
        handleRemoveCard(selectedPaymentCard, savedCards).then((response) => {
            if (response?.data.success) {
                setIsOpen(!isOpen);
                Store.addNotification({
                    title: null,
                    message: "Card Removed Successfully!",
                    type: "success",
                    // insert: "center",
                    container: "bottom-center",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 2000
                    }
                });
                setCardsFetching(true);
                setDeleted(true);
            } else {
                setIsLoadingCards(false);
                Store.addNotification({
                    title: null,
                    message: "error in deleting card!",
                    type: "danger",
                    // insert: "center",
                    container: "bottom-center",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                        duration: 2000
                    }
                });
            }
        });
    };

    const showTrailText = () => {
        if (membership?.is_trial_available && membership?.type?.toUpperCase() === "PUBLIC") {
          return true;
        }
        return false;
    }

    const unit = membership?.period?.includes('Month')
    ? 30
    : membership?.period?.includes('Year')
    ? 365
    : 0;

    const data: IMembershipRequest = {
        player_id: currentUser?.uid || '',
        birth_date: formData!.Date_of_birth,
        phone_number: formData!.Phone_number,
        address: formData!.Address,
        postal_no: formData!.Postal_no,
        county: formData!.County,
        country: formData!.Country,
        club_id: membership!.club_id,
        membership_id: membership!._id,
        following: membership!.following,
        payment_status: '', // eita remove korte hobe
        next_payment: moment?.utc(membership!.start_date)?.tz(membership!.timezone)?.add(unit, 'days')?.utc()?.valueOf(),
        subscription_id: '',
        Date_of_birth: formData!.Date_of_birth,
        personalNumber: formData!.Personal_Number,
      };

    const handleActiveMembership = async (paymentRes: {
        success: boolean;
        message: string;
        transactionId: string;
      }) => {
        const { transactionId } = paymentRes;
    
        if (!transactionId) {
            Store.addNotification({
                title: null,
                message: "Payment failed",
                type: "danger",
                container: "bottom-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 3000
                }
            });
          return;
        }
    
        data.payment_status = 'PAYMENT_SUCCESS';
        data.subscription_id = transactionId;
    
        try {
          await activeMembership(data);
          Store.addNotification({
            title: null,
            message: t("membershipActivated"),
            type: "success",
            container: "bottom-center",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 3000
            }
          });
          setLoading(true);
          try {
            const membershipResp = await getClubMemberships(clubData?._id);
            if (
              membershipResp &&
              membershipResp?.data?.memberships &&
              membershipResp?.data?.memberships?.length
            ) {
                const filterData = membershipResp?.data?.memberships?.filter(
                    (membership: any) => membership.hidden === false
                  );
                  setClubMemberships(filterData || []);
            }
          } catch (error) {
          } finally {
              setLoading(false);
          }
        } catch (error) {
        }
      };

      const clearCardDetails = () => {
        setCardDetails(null);
        setSaveCardForFutureUse(false);
      };

      const confirmPaymentWith3DSecure = async (
              intent: IPaymentIntent | any,
              cardDetails?: any
          ) => {
              if (!stripe) return;
          
              const confirmCardPaymentParams: ConfirmCardPaymentData = {};
              const localActiveCardString = localStorage.getItem('activeCard');
              const localActiveCard = localActiveCardString ? JSON.parse(localActiveCardString) : null;
              const paymentMethodId = localActiveCard?.stripePaymentMethodId;
          
              if (paymentMethodId && !cardDetails) {
                  confirmCardPaymentParams.setup_future_usage = "off_session";
              }
          
              if (cardDetails && cardElement) {
                  confirmCardPaymentParams.payment_method = {
                      card: cardElement,
                      billing_details: {
                          name: currentUser?.displayName,
                          email: currentUser?.email
                      }
                  };
              } else if (paymentMethodId) {
                  confirmCardPaymentParams.payment_method = paymentMethodId; // only send for existing cards
              }
          
              const confirmPayment = await stripe.confirmCardPayment(
                  intent?.clientSecret,
                  confirmCardPaymentParams
              );
              if (confirmPayment) return confirmPayment;
          };

        // create intent for subscription
        const createMembershipSubscriptionIntent = async ({
          planId,
          planDuration,
          amount,
          currency,
          sourcePaymentMethodId,
          url,
          clubId,
          description,
          userInfo,
          salexTax,
          card
          }: {
          planId: string;
          planDuration: number;
          amount: number;
          currency: string;
          sourcePaymentMethodId: string;
          url: string;
          clubId?: string;
          description?: string;
          userInfo?: any;
          salexTax?: any;
          card?: any
        }) => {
          try {
          let requestData: any = {
          planId,
          planDuration,
          amount,
          currency,
          sourcePaymentMethodId,
          clubId,
          description,
          userInfo,
          salexTax,
          };
          
          if (saveCardForFutureUse && cardDetails) {
            if (!stripe) return;
            let _cardDetailsFromStripeTokenForIntent;
                if (cardDetails && cardElement) {
                    const { token, error } = await stripe.createToken(
                        cardElement
                    );
                    if (token && !error) {
                        _cardDetailsFromStripeTokenForIntent = {
                            last4: token.card?.last4,
                            expiryMonth: token.card?.exp_month,
                            expiryYear: Number(
                                token.card?.exp_year.toString().slice(-2)
                            ),
                            complete: true,
                            brand: token.card?.brand,
                            validExpiryDate: "Valid",
                            validNumber: "Valid",
                            validCVC: "Valid"
                        };
                    }
                }

              requestData = {
                planId,
                planDuration,
                amount,
                currency,
                clubId,
                description,
                // @ts-ignore
                cardDetails: _cardDetailsFromStripeTokenForIntent || cardDetails,
                userInfo,
                salexTax,
              };
          } else if (saveCardForFutureUse && !cardDetails) {
            Store.addNotification({
                title: null,
                message: "Please fill up card details or select a card",
                type: "danger",
                container: "bottom-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 3000
                }
            });
            return;
          } else if (card) {
            requestData = {
              planId,
              planDuration,
              amount,
              currency,
              clubId,
              description,
              userInfo,
              salexTax,
            };
          }
        
          const { data } = await Axios.post(url, requestData);
        
          return data as IPaymentIntent;
          } catch (error) {
          throw error;
          }
        };

      // manageClubSubscription
      const manageClubSubscription = async ({
        planId,
        planDuration,
        amount,
        currency,
        clubId,
        description,
        userInfo,
        salexTax,
        cardDetails,
        cardElement,
        stripe,
        currentUser
      }: {
        amount: number;
        clubId: string;
        currency: string;
        description: string;
        planDuration: number;
        planId: string;
        userInfo?: any;
        salexTax?: any;
        cardDetails: any;
        cardElement: any;
        stripe: any;
        currentUser: any
      }) => {
        try {
          const localActiveCard = localStorage.getItem('activeCard');
          const card: ICard = JSON.parse(localActiveCard || '{}');
        //   dispatch(setLoadingPaymentStatus(true));
          // getting intent
          const intent = await createMembershipSubscriptionIntent({
            amount,
            currency,
            planDuration,
            planId,
            sourcePaymentMethodId: card.stripePaymentMethodId as string,
            url: '/subscription/membership/request',
            description,
            clubId,
            userInfo,
            salexTax,
            card: card,
          });

          if(!intent) {
            return;
          }
    
          // confirm with 3d secure
          const paymentResponse: any = cardDetails
          ? await confirmPaymentWith3DSecure(intent, cardDetails)
          : await confirmPaymentWith3DSecure(intent);
    
          if (paymentResponse) {
            if (paymentResponse?.code === 'Failed') {
              return paymentResponse;
            }
            // confirm subscription
            let responseFromChargeCheck = await checkPaymentChargeWithCondition(
              intent?.paymentIntentId, true
            );
            clearCardDetails();
            if (responseFromChargeCheck) {
              setOpenSuccessModal(true);
              return responseFromChargeCheck.data;
            }
            return {'code':'Failed','message': 'Payment failed. Try again later.'};
    
          } else {
            throw new Error('Failed to confirm subscription');
          }
        } catch (error: any) {
    
          const errorMsg = error.response?.data?.message?.includes(
            'You cannot combine currencies'
          )
            ? 'currencyError'
            : null;
    
          if (errorMsg) {
            throw new Error(errorMsg);
          } else {
            throw error;
          }
        } finally {
        //   setLoadingPaymentStatus(false);
        }
      };

    const handleCardPay = async () => {
        try {
          setDisablePayClick(true);
    
          const response = await manageClubSubscription({
            amount: fareAmountMembership() || membership?.price || 0,
            clubId: membership?.club_id || '',
            currency: clubData?.currency || '',
            description: '',
            planDuration: membership?.duration || 0,
            planId: membership?.price_id || '',
            userInfo: data,
            salexTax: clubData?.salestax,
            cardDetails: cardDetails,
            cardElement: cardElement,
            stripe: stripe,
            currentUser: currentUser
          });
    
          setDisablePayClick(false);

          if(!response){
            return;
          }
    
          if (!checkNullAndUndefined(response) && response) {
            if (response.code === 'Failed') { 
              setErrorMessage(response.message);
              return;
            }
          }
          if (membership?.type === 'Public') {
            Store.addNotification({
                title: null,
                message: t("membershipActivated"),
                type: "success",
                container: "bottom-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 3000
                }
            });
            setLoading(true);
            try {
              const membershipResp = await getClubMemberships(clubData?._id);
              if (
                membershipResp &&
                membershipResp?.data?.memberships &&
                membershipResp?.data?.memberships?.length
              ) {
                  const filterData = membershipResp?.data?.memberships?.filter(
                      (membership: any) => membership.hidden === false
                    );
                    setClubMemberships(filterData || []);
              }
            } catch (error) {
            } finally {
                setLoading(false);
            }
            
          } else {
            Store.addNotification({
                title: null,
                message: t("BookingModal.paymentSuccessful"),
                type: "success",
                container: "bottom-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 3000
                }
            });
            
            handleActiveMembership(response);
          }
          
        } catch (error: any) {
          if(error && error?.response && error?.response?.data?.message instanceof Array) {
            let errorMessage = '';
            error?.response?.data?.message.forEach((message: string) => {
              if(errorMessage === '') {
                errorMessage = message;
              } else {
                errorMessage = errorMessage + ' \n ' + message;
              }
            })
            Store.addNotification({
                title: null,
                message: errorMessage,
                type: "danger",
                container: "bottom-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 3000
                }
            });
          } else if(error && error?.response && error?.response?.data?.message) {
            Store.addNotification({
                title: null,
                message: error?.response?.data?.message,
                type: "danger",
                container: "bottom-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 3000
                }
            });
          } else {
            Store.addNotification({
                title: null,
                message: error?.message,
                type: "danger",
                container: "bottom-center",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 3000
                }
            });
          }
          setDisablePayClick(false);
          // const msg = error?.message === 'currencyError' ? t('currencyError') : error?.message;
          // showFlashMessage(msg || 'Payment failed', 'danger');
          setModalVisible(false);
          setOpenMembershipPaymentDetails(false);
        } finally {
          setDisablePayClick(false);
        }
      };

  const endDateMembership = () => {
    const millisecondsInADay = 86400000;
    const endDate = moment().valueOf() + (unit * millisecondsInADay);
    return endDate
  }

  const returnMembershipPeriod = () => {
    const period = membership?.period?.includes('Month')
    ? t("monthly")
    : membership?.period?.includes('Year')
    ? t("yearly")
    : t("monthly");
    return period;
  }

  return (
    <div className="bg-white font-semibold rounded w-full max-w-lg sm:min-w-[512px] mx-auto z-[5100]">
        {openSuccessModal ? <><div className="text-white bg-secondary py-5 flex items-center justify-between flex-wrap gap-4 md:rounded-t text-2xl font-semibold px-5">
          <h4
              id="enterCode"
              className="text-2xl lg:text-3xl font-semibold"
          >
              {t("BookingModal.paymentSuccessful")}
          </h4>
          <button
              className="btn"
              onClick={() => {
                setOpenMembershipPaymentDetails(false);
              }}
          >
              <AiOutlineClose className="pointer-events-none touch-none w-6 h-6 lg:w-8 lg:h-8 text-[#FF3A3A] hover:scale-110 transform duration-200" />
          </button>
      </div><MembershipSuccessModal setOpenMembershipPaymentDetails={setOpenMembershipPaymentDetails} /></> : <>{isModalVisible && <div className="text-white bg-secondary py-5 flex items-center justify-between flex-wrap gap-4 md:rounded-t text-2xl font-semibold px-5">
          <h4
              id="enterCode"
              className="text-2xl lg:text-3xl font-semibold"
          >
              {t("payNow")}
          </h4>
          <button
              className="btn"
              onClick={() => {
                setOpenMembershipPaymentDetails(false);
              }}
          >
              <AiOutlineClose className="pointer-events-none touch-none w-6 h-6 lg:w-8 lg:h-8 text-[#FF3A3A] hover:scale-110 transform duration-200" />
          </button>
      </div>}
    {isModalVisible ? (<>
      <Popup
        onDelete={handleDeleteCard}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title={"Delete Card"}
        message={"Are you sure you want to delete the selected card?"}
      />
      {isLoadingCards && <PopupInfo
          title={infoPopupTitle}
          subTitle={infoPopupSubtitle}
          isOpen={isLoadingCards}
          setIsOpen={setIsLoadingCards}
          isLoading={true}
      />}
      {(disablePayClick || isLoading) && <PopupInfo
          title={`${t("processingThePayment")}...`}
          subTitle={""}
          isOpen={disablePayClick}
          setIsOpen={setDisablePayClick}
          isLoading={true}
      />}
      <div className="overflow-y-auto p-5 relative text-sm font-normal max-h-[80vh]">
    <div>
    {showCardPayment && stripe && (
    <div>
        <div className="flex flex-col mt-6 w-full overflow-y-auto p-5 relative text-sm font-normal">
            <div className="w-full md:max-w-[585px] h-full flex items-center mb-6">
                <div className="border-2 border-[#00000033] rounded-[8px] p-3 text-lg w-full md:max-w-[585px] outline-primary min-h-[50px] flex items-center">
                    <CardElement
                        className="w-full"
                        onChange={handleCardElementChange}
                        options={{ hidePostalCode: true }}
                        onReady={(element) => {
                            cardElementRef.current = element;
                            handleCardElementSelect(
                                cardElementRef.current
                            );
                        }}
                    />
                </div>
            </div>
            <p>{t("saveCardMembership")}</p>
            <br />
            <div className="flex md:justify-start justify-center gap-2 items-center">
                {/* <button
                    className="text-base outline-none bg-white border border-secondary py-1 text-secondary px-2 rounded-lg w-[150px] hover:bg-primary hover:border-none transform duration-200"
                    onClick={() => handleSubmit()}
                >
                    {t("PaymentComponent.save")}
                </button> */}
                <button
                    className="text-base outline-none bg-white border border-secondary py-1 text-secondary px-2 rounded-lg w-[150px] hover:bg-red-500 hover:text-white hover:border-none transform duration-200"
                    onClick={() => {
                      setShowCardPayment(false);
                      setSaveCardForFutureUse(false);
                      const localActiveCardString = localStorage.getItem("activeCard");
                      const localActiveCard = localActiveCardString
                          ? JSON.parse(localActiveCardString)
                          : null;
                      setSelectedCard(localActiveCard.stripePaymentMethodId);
                    }}
                >
                    {t("PaymentComponent.cancel")}
                </button>
            </div>
        </div>
    </div>
    )}
    {
    showSavedCards &&
    savedCards &&
    savedCards.length ? (
        <div className="flex flex-col mt-5 mb-3">
            <h6 className="text-lg">
                {t("PaymentComponent.select")}
            </h6>
            <div className="flex flex-col mt-3">
                {savedCards?.map((card: any, index) => (
                    <div
                        id={`savedCard-${index}`}
                        className={`border-y flex gap-3 flex-wrap justify-between items-center py-1 px-5 hover:cursor-pointer hover:transform hover:scale-[1.02] duration-200 ease-in-out ${
                            selectedCard ===
                            card.stripePaymentMethodId
                                ? "border-black"
                                : "border-gray-300"
                        }`}
                        key={card.stripePaymentMethodId}
                        onClick={() => {
                            setSelectedCard(
                                card.stripePaymentMethodId
                            );
                            localStorage.setItem(
                                "activeCard",
                                JSON.stringify(card)
                            );
                            setSaveCardForFutureUse(false);
                        }}
                    >
                        <div className="flex items-center gap-3">
                            <div>
                                {selectedCard ===
                                card.stripePaymentMethodId ? (
                                    <BsCheckCircleFill />
                                ) : (
                                    <BsCheckCircle />
                                )}
                            </div>
                            <div className="flex items-center gap-1 flex-wrap">
                                <h6 className='capitalize'>{card.brand}</h6>
                                <p>
                                    ( . . . . {card.last4Digit}{" "}
                                    )
                                </p>
                            </div>
                        </div>

                        <div>
                            <button
                                id={`savedCardRemove-${index}`}
                                className="border border-black bg-white rounded-full text-sm py-1 px-4 hover:bg-secondary hover:text-white transform duration-200 ease-in-out"
                                onClick={() =>
                                    setIsOpen(!isOpen)
                                }
                            >
                                Remove
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    ) : isLoadingCards ? (
        <h1 className="text-center h-full flex justify-center items-center mt-5">
            {t("PaymentComponent.fetch")}...
        </h1>
    ) : (
        <h1 className="text-center h-full flex justify-center items-center mt-5">
            {t("PaymentComponent.notFound")}
        </h1>
    )}
    { !showCardPayment && (
        <div className="flex justify-center items-center">
            <button
                className="text-base outline-none bg-secondary border border-secondary py-1 text-white px-2 rounded-lg w-[150px] mt-5 hover:bg-primary hover:border-primary hover:text-secondary transform duration-200"
                onClick={() => {
                  setSelectedCard("");
                  setShowCardPayment(true);
                  setSaveCardForFutureUse(true);
                }}
            >
                {t("PaymentComponent.addCard")}
            </button>
        </div>
    )}
    </div>
    { !checkNullAndUndefined(clubData?.salestax) && clubData?.salestax?.salestax_on_top ? <div className="mt-8 text-xl">
        <div className='w-full flex justify-between items-center flex-wrap gap-2'>
          <div>
            <p>{t("SubTotalComponent.subtotal")}:</p>
          </div>
          <div>
            <p className="font-medium">{membership?.price} {clubData?.currency}</p>
          </div>
        </div>
        <div className="pt-2 w-full flex justify-between items-center flex-wrap gap-2">
          <div>
            <p>{t("SubTotalComponent.tax")}:</p>
          </div>
          <div>
            <p className="font-medium">{correctAmountWithDecimal(salesTaxAmount())} {clubData?.currency}</p>
          </div>
        </div>
        {/* { isSplitPayment ? <div className="pb-4 pt-2 w-full px-2.5">
          <div>
            <p>{"Split fee"}:</p>
          </div>
          <div>
            <p>{splitPayFeeUnit} {clubData?.currency}</p>
          </div>
        </div> : null} */}
      </div> : null }
      <div className={`${!checkNullAndUndefined(clubData?.salestax) && clubData?.salestax?.salestax_on_top ? "": "mt-8"} pb-4 pt-2 w-full flex justify-between items-center flex-wrap gap-2 text-xl`}>
          <div>
            <p>{t("SubTotalComponent.total")}:</p>
          </div>
          <div>
            <p className="font-medium">{correctAmountWithDecimal(correctAmountWithDecimal(fareAmountMembership()))} {clubData?.currency}</p>
          </div>
      </div>
      {showTrailText()  ? <p className='text-sm mt-4'>
                {t("membershipPaymentTrial")}
              </p> : null}

        {errorMessage && <p className='text-center text-red-500 text-sm mt-2'>{errorMessage}</p>}
              
        {/* {(typeof paymentMethodInfo !== 'string' && paymentMethodInfo?.activeCard) || addCardEnabled ? ( */}
        <div className='flex justify-center items-center gap-4 flex-wrap-reverse mb-4 mt-8'>
        <button onClick={()=>{setModalVisible(false);}} className='text-base capitalize bg-secondary min-w-[200px] max-w-[300px] py-3 px-4 text-white rounded-full'>{t("back")}</button>
        <button
            disabled={disablePayClick}
            onClick={handleCardPay}
            className="text-base bg-secondary min-w-[200px] max-w-[300px] px-4 py-3 rounded-full text-white"
        >
            <p>{t('payNow')}</p>
        </button>
        </div>
        {/* ) : null} */}
    </div>
    </>) : (
        <div>
      <div className="text-white bg-secondary py-5 flex items-center justify-between flex-wrap gap-4 md:rounded-t text-2xl font-semibold px-5">
          <h4
              id="enterCode"
              className="text-2xl lg:text-3xl font-semibold"
          >
              {t("summary")}
          </h4>
          <button
              className="btn"
              onClick={() => {
                setOpenMembershipPaymentDetails(false);
              }}
          >
              <AiOutlineClose className="pointer-events-none touch-none w-6 h-6 lg:w-8 lg:h-8 text-[#FF3A3A] hover:scale-110 transform duration-200" />
          </button>
      </div>
      <div className="overflow-y-auto p-5 relative text-sm font-normal max-h-[80vh]">
        <div className='mb-4 border-b-2 pb-2'>
        <p className='capitalize font-medium'>{membership.name} {t("Profile.membership")}</p>
        { membership?.type !== 'Public' && (
          <div className='flex justify-between items-center mt-1'>
              <p
              >
                {t("period")}
              </p>
              <p className='font-medium'>
                {moment().format('DD MMM YYYY')} - {moment(endDateMembership()).format('DD MMM YYYY')}
              </p>
            </div>
        )}
        </div>
        <p className='text-gray-500 mb-4'>Your Information</p>
        <p>{currentUser?.displayName}</p>
        {formData.Date_of_birth && <p>{moment(formData.Date_of_birth).format('YYYY/MM/DD')}</p>}
        {formData.Personal_Number && <p>{formData.Personal_Number}</p>}
        <p>{formData.Address}</p>
        <p>{formData.Postal_no}</p>
        <p>{formData.County}</p>
        <p>{formData.Country}</p>
        <div className='mt-4'>
          {formData?.Phone_number && <p>{formData.Phone_number}</p>}
          <p>{currentUser?.email}</p>
        </div>
        <div className='py-2 border-y-2 text-base flex justify-between mt-16'>
          <p className='text-gray-500'>{t("totalPayment")}</p>
          <p className='lowercase font-medium'>{membership?.price} {membership?.currency? membership?.currency : clubData?.currency}/{returnMembershipPeriod()}</p>
        </div>
        <div className='flex justify-center items-center gap-4 flex-wrap-reverse mt-8 mb-4'>
          <button onClick={()=>{setOpenMembershipModal(true); setOpenMembershipPaymentDetails(false);}} className='text-base capitalize bg-secondary min-w-[200px] max-w-[300px] py-3 px-4 text-white rounded-full'>{t("back")}</button>
          <button onClick={()=>setModalVisible(true)} className='text-base capitalize bg-secondary min-w-[200px] max-w-[300px] py-3 px-4 text-white rounded-full'>{t("payNow")}</button>
        </div>
      </div>
    </div>
    )}</>}
    </div>
  )
}
